import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import withAuth from '../../../../components/Services/WithAuth'
import { assignToCorrespondent, getCorrespondentList } from '../action'
import Table from '../../../../components/UI/Table/Table'
let that = this
export const tableColumns = [
    {
        Header: "",
        id: "user",
        accessor: p => <div><input type="radio" name="user" onChange={() => that.handleSelectedCorrespondent(p)} /></div>,
        minWidth: 20
    },
    {
        Header: "User Name",
        id: "userName",
        accessor: "userName",
    },
    {
        Header: "Correspondent Entity Name",
        id: "correspondentEntityName",
        accessor: "correspondentEntityName",
    },
    {
        Header: "# of assigned case",
        id: "currentLoad",
        accessor: p => <div className="text-center">{p.currentLoad}</div>,
    },
    {
        Header: "State",
        id: "state",
        accessor: "state",
    },
    {
        Header: "City",
        id: "city",
        accessor: "city",
    },
    {
        Header: "Address",
        id: "address",
        accessor: "address",
    },


]
class AssignToCorrespondent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            userDetails: {},
            loading: true
        };
        that = this
    }
    componentDidMount() {
        this.props.getCorrespondentList(this.props.sectionTemplateId);
    }

    handleSelectedCorrespondent = (param) => {
        this.setState({
            userDetails: param
        })
    }
    componentDidUpdate(prevprops) {
        if (this.props.correspondentList && this.props.correspondentList !== prevprops.correspondentList) {
            this.setState({
                loading: false
            })
        }
    }
    assignCorrespondent = () => {
        this.props.assignToCorrespondent(this.props.taskId, this.state.userDetails, this.props.computedReportId)
        this.props.toggle()
    }

    render() {
        let disable = Object.keys(this.state.userDetails).length > 0 ? false : true
        return (
            <div>
                {/* <TemplateDropdown selected={this.handleSelectedCorrespondent} correspondentList={data} /> */}
                <Table
                    data={this.props.correspondentList}
                    columns={tableColumns}
                    defaultPageSize={5}
                    defaultSorted={[
                        {
                            id: "deliveryDate",
                            desc: true
                        }
                    ]}
                    loading={this.state.loading}
                    noDataText="No correspondents offer this section template!"
                    className="CreateCaseModalTable highlight"
                />
                <Button color="primary" className="mt-5" onClick={this.assignCorrespondent} disabled={disable}>Assign</Button>
                <Button color="danger" className="mt-5 ml-3" onClick={this.props.toggle}>Cancel</Button>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    correspondentList: state.section.correspondentList,
})

const mapDispatchToProps = (dispatch) => ({
    assignToCorrespondent: (id, data, computedReportId) => { dispatch(assignToCorrespondent(id, data, computedReportId)) },
    getCorrespondentList: (sectionTemplateId) => { dispatch(getCorrespondentList(sectionTemplateId)) }

});

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(AssignToCorrespondent))
